import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { errorToast, successToast } from "../../Utils/utils";


export function loadSendFeedbackFunctionality(){
    $(".send-feedback").on("click", function(){
        const feedback = $("#feedback").val().toString();
        if (feedback !== undefined && feedback !== ''){
            const player = document.querySelector("#lottie-mail");
            player.style.width = "120px";
            player.style.height = "120px";
            player.style.top = "-60px";
            player.style.right = "-60px";
            player.addEventListener('complete', function(){
                player.stop();
                player.seek(0);
                player.style.width = "40px";
                player.style.height = "40px";
                player.style.top = "-9px";
                player.style.right = "3px";
            });
            player.play();
            sendFeedback(feedback);
        } else {
            errorToast("Bitte gib dein Feedback ein vor dem Absenden", "Fehler", 12500, true);
        }
    });
}

function sendFeedback(feedback:string){

    const url = '/feedback/send'

    const data = {
        feedback: feedback
    }

    const success = function (data){
        successToast("Danke für dein Feedback!", "Erfolg", 8500, true);
        $("#feedback").val('');
    }

    ajaxRequest(url, success, data);

}